import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js"
import { ScrollToPlugin } from "gsap/ScrollToPlugin.js"
import { ScrollSmoother } from "gsap/ScrollSmoother.js"

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, ScrollToPlugin)
gsap.registerPlugin()

window.gsap = gsap
window.ScrollTrigger = ScrollTrigger
window.ScrollSmoother = ScrollSmoother

import { Game } from "game"
window.game = new Game(play, mpcheck, mpplayer, ctx)

document.addEventListener( 'DOMContentLoaded', function() {

    ScrollSmoother.create({
        smooth: 0.75,
        smoothTouch: 0.05,
        effects: true
    })

    const anchors = document.querySelectorAll('a[href*="#"]')
    anchors.forEach((el) => {
        el.addEventListener('click', (e)=>{
            e.preventDefault()
            const self = e.currentTarget
            const href = self.getAttribute('href')
            const id = href.substring(href.indexOf('#')+1);
            const target = document.getElementById(id)
            if (target) {
                let offset = window.outerWidth < 600 ? 0 : 0
                gsap.to(window, {
                    scrollTo: {
                        duration: 0.7, 
                        y: target,
                        offsetY: offset
                    },
                    ease: "power3"
                });
            }

        })
    })
})
